import Image from "next/legacy/image";
import styled from "@emotion/styled";

import logo from "public/images/logo/login_black.svg";
import FunnelLnb from "../src/components/atoms/FunnelLnb";
import {
  grayScale,
  mBody2,
  mHeader2,
  wBody2,
  wHeader2,
} from "@teamsparta/design-system";
import { DESKTOP } from "../src/styles/themes/device";
import ChannelTalkBtn from "../src/components/atoms/ChannelTalkBtn";

export default function Custom404() {
  return (
    <>
      <FunnelLnb />
      <StyledWrapper>
        <Image src={logo} alt="logo" />
        <StyledHeader>
          죄송합니다,
          <br /> 요청하신 페이지를 찾을 수 없습니다.
        </StyledHeader>
        <StyledDesc>
          <br /> 입력하신 페이지의 주소가 잘못 입력되었거나,
          <br /> 더 이상 존재하지 않는 페이지입니다.
          <br /> 문의가 필요할 경우, 하단 1:1 문의 버튼을 클릭해 주세요.
        </StyledDesc>
      </StyledWrapper>
      <ChannelTalkBtn />
    </>
  );
}

export const StyledWrapper = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: calc(100vh - 50px);
  background-color: ${grayScale.gray10};
  align-items: center;
  ${DESKTOP} {
    height: calc(100vh - 60px);
  }
`;

export const StyledHeader = styled.div`
  text-align: center;
  ${mHeader2};
  font-weight: 500;
  padding-top: 6px;
  ${DESKTOP} {
    padding-top: 10px;
    ${wHeader2};
  }
`;

export const StyledDesc = styled.p`
  text-align: center;
  ${mBody2};
  color: ${grayScale.gray80} !important;
  ${DESKTOP} {
    ${wBody2};
  }
`;
